var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterVIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4609 4.51562C17.5781 2.25 16.7188 1.07812 14.9219 1.03906C12.5 0.960938 10.8594 2.32812 10 5.14062C11.0938 4.67188 12.6562 4.55469 12.5 6.35156C12.4219 6.9375 12.0312 7.83594 11.2891 8.96875C9.25781 12.2109 8.75 11.1172 7.65625 4.04688C7.34375 2.05469 6.48438 1.11719 5.11719 1.23438C3.90625 1.35156 1.99219 3.30469 0 5.10156L0.820312 6.15625C1.60156 5.60938 2.03125 5.33594 2.1875 5.33594C3.32031 5.33594 3.90625 8.26562 5.27344 13.3438C5.97656 15.2188 6.83594 16.1562 7.85156 16.1562C9.53125 16.1562 11.5234 14.5938 13.9062 11.5078C16.2109 8.53906 17.3828 6.23438 17.4609 4.51562Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterVIcon);
export default __webpack_public_path__ + "static/media/footer_V_Icon.849c318cbf0e4d564a1d48afa62327dd.svg";
export { ForwardRef as ReactComponent };